export const PERMISSION_TYPE = {
    ALL: "all",
    ADMIN: "admin",
    COSTS: "costs",
    LOGS: "logs",
    NPD: "npd",
    PDD: "pdd",
    PRODUCT_ATTRIBUTES_DICTIONARY: "padictionary",
};
